/**
 * @class
 * @param {array} content
 * @extends mkE.Base
 */
T.Slider = Class(
	/**
	 * @lends {T.Slider#}
	 */
	{

		/** @type {HTMLElement|null} */
		_listNode: null,

		/** @param {array} content */
		__construct( content ) {
			this.node = mkE({
				tag: 'div',
				className: 't-slider',
				els: [
					this._btnPrevNode = mkE({
						tag: 'a',
						className: 'ctrl ctrl-prev',
						onclick: this.prev,
						style: {
							display: 'none'
						},
						els: [
							D.svgIcon('arrow-left')
						]
					}),
					this._listNode = mkE({
						tag: 'div',
						className: 'wrapper',
						ontouchstart: this.onTouchStart,
						ontouchmove: this.onTouchMove,
						els: content
					}),
					this._btnNextNode = mkE({
						tag: 'a',
						className: 'ctrl ctrl-next',
						onclick: this.next,
						style: {
							display: 'none'
						},
						els: [
							D.svgIcon('arrow-right')
						]
					})
				]
			});
		},
		onShow() {
			this.refresh();
		},
		refresh() {
			const count = this._listNode.children.length;
			const containerWidth = this._listNode.clientWidth;
			const itemWidth = count ? this._listNode.children[0].clientWidth : 0;
			let perPage = Math.floor(containerWidth / itemWidth);
			if( perPage === 1 ) {
				perPage++;
			}
			if( count > perPage && perPage > 0 ) {
				for( let i = 0; i < perPage; i++ ) {
					this._listNode.appendChild(this._listNode.children[i].cloneNode(true));
				}
				this._btnPrevNode.style.display = '';
				this._btnNextNode.style.display = '';
			}
		},
		/** @param {int} dir */
		scroll( dir ) {
			const itemWidth = this._listNode.children.length ? this._listNode.children[0].clientWidth : 0;
			const scrollTo = this._listNode.scrollLeft + itemWidth * dir;
			const max = this._listNode.scrollWidth - this._listNode.clientWidth;
			if( scrollTo > max ) {
				this._listNode.scroll({
					top: 0,
					left: 0,
					behavior: 'instant'
				});
				this.scroll(dir);
			} else if( scrollTo < 0 ) {
				this._listNode.scroll({
					top: 0,
					left: max,
					behavior: 'instant'
				});
				this.scroll(dir);
			} else {
				this._listNode.scroll(scrollTo, 0);
			}
		},
		prev() {
			this.scroll(-1);
		},
		next() {
			this.scroll(1);
		},
		/** @param {TouchEvent} e */
		onTouchStart( e ) {
			this.startX = e.changedTouches[0].screenX;
			this.startY = e.changedTouches[0].screenY;
		},
		/** @param {TouchEvent} e */
		onTouchMove( e ) {
			if( !this._listNode.children.length ) {
				return;
			}
			const diffX = e.changedTouches[0].screenX - this.startX;
			const diffY = e.changedTouches[0].screenY - this.startY;
			const ratioX = Math.abs(diffX / diffY);
			const ratioY = Math.abs(diffY / diffX);
			const absDiff = Math.abs(ratioX > ratioY ? diffX : diffY);

			// Ignore small movements.
			if( absDiff < 30 ) {
				return;
			}

			if( ratioX > ratioY ) {
				const dir = diffX >= 0 ? -1 : 1;
				const offset = 16;
				const max = this._listNode.scrollWidth - this._listNode.clientWidth;
				const itemWidth = max / this._listNode.children.length;
				const scrollTo = this._listNode.scrollLeft + itemWidth * dir - offset;
				if( scrollTo > max ) {
					this._listNode.scroll({
						top: 0,
						left: 0,
						behavior: 'instant'
					});
				} else if( scrollTo < offset ) {
					this._listNode.scroll({
						top: 0,
						left: max - itemWidth,
						behavior: 'instant'
					});
				}
			}
		}
	},
	mkE.Base
);

